export const globalMessageEn = {
  deactivate: "deactivate",
  success: "Success",
  search_placeholder: "Search ...",
  array_placeholder: "multiple comma-separated",
  select_placeholder: "Select ...",
  select_datetime: "Select datetime",
  select_variable: "Select variable",
  press_enter_search: "Press enter to search",
  delete_success: "Deleted successfully",
  delete_failed: "Failed to delete",
  duplicate_success: "Duplicated successfully",
  duplicate_failed: "Failed to duplicate",
  create_success: "Created successfully",
  create_failed: "Failed to create",
  update_success: "Updated successfully",
  update_failed: "Failed to update",
  upload_success: "Uploaded successfully",
  upload_failed: "Failed to upload",
  authenticate_success: "Authenticated successfully",
  authenticate_failed: "Failed to authenticate",
  revealed_success: "Revealed successfully",
  revealed_failed: "Failed to reveal",
  activate_success: "Activated successfully",
  activate_failed: "Failed to activate",
  deactivate_success: "Deactivated successfully",
  deactivate_failed: "Failed to deactivate",
  import_failed: "Failed to import",
  import_success: "Imported successfully",
  export_failed: "Failed to export",
  export_success: "Exported successfully",
  download_failed: "Failed to download",
  download_success: "Downloaded successfully",

  remove_success: "Removed successfully",
  remove_failed: "Failed to remove",

  invite_success: "Invited successfully",
  invite_failed: "Failed to invite",

  redeem_success: "Redeemed successfully",

  export_credits_title: "Export {type} to CSV",
  export_credits_desc:
    "You’re about to export {type}. This may take a few moments, depending on the size of your selection.",
  unsave: "Unsave",
  draw_failed: "Failed to draw",
  please_fill: "Please fill in the form first",
  field_not_valid: "not valid",
  enable: "Enable",
  disabled: "Disabled",
  under_the_min_length: "Less than the minimum number",
  over_the_max_length: "Exceeding the maximum number",
  under_the_min_value: "Less than the minimum value",
  over_the_max_value: "Exceeding the maximum value",
  /** sort filter start */
  sort_filter_panel_title: "Sort & Filter",
  sort_filter_panel_reset: "Reset",
  sort_filter_panel_sort_by_title: "Sort by",
  sort_filter_panel_filter_title: "Filter",
  sort_filter_sort_by_create_descending: "Date Created (Newest First)",
  sort_filter_sort_by_create_ascending: "Date Created (Oldest First)",
  sort_filter_sort_by_modify_descending: "Last Modified (Recent First)",
  sort_filter_sort_by_modify_ascending: "Last Modified (Oldest First)",
  /** sort filter end */
  days: "Days",
  hours: "Hours",
  minutes: "Minutes",
  apply: "Apply",
  sequence_editor_toolbar_link_form_text: "Text",
  sequence_editor_toolbar_link_form_url: "URL",

  authenticate_failure_title: "Connection Failed",
  authenticate_failure_desc:
    "We couldn't connect your credentials. Please check your details and try again.",
  authenticate_failure_button_text: "close",
  authenticate_success_title: "Connection Successful",
  authenticate_success_desc:
    "Your account is now linked. You can start using it.",
  authenticate_success_button_text: "close",

  selections_desc_max:
    "Select up to 0 with your current plan. | Select up to 1 with your current plan. | Select up to {count} with your current plan.",
  selections_upgrade_now: "Upgrade now ",
  selections_upgrade_now_desc: "to access even more!",

  not_email_format: "not match the email format",
  run_success: "Run successfully",
  run_failed: "Run failed",
  signUpFailed: "Sign up failed",
  signUpSuccess: "Sign up successfully",

  save_success: "Saved successfully",
  save_failed: "Failed to save",
  send_email_success: "An email was sent to your email address.",
  send_email_failed: "Failed to send email",

  empty_list: "Nothing here",

  retry: "Retry",

  remove_styles: "Remove styles",

  is_required: "{0} is required",

  current_page: "This page",
  customize: "Customize",

  field_required: "This field is required.",

  select_year: "Select year",
  select_month: "Select month",

  asending: "asending",
  descending: "descending",
  copy: "Copy",

  non_permission_field: "You don’t have permission to edit this field",
  access_denied_title40348: "Access request declined",
  access_denied_desc40348:
    "Your request to access this section was declined by your workspace admin. You can contact your admin for more details or try again later.",
  access_denied_request40348: "Request access",
  access_denied_title40349: "Subscription permission decline",
  access_denied_desc40349:
    "Your current plan doesn’t include access to this feature. Upgrade your subscription to continue.",
  access_denied_request40349: "Upgrade subscription",

  no_admin_found: "Sorry, no administrator account could be found.",

  started_at: "Started {0}",
  will_ends: "Ends {0}",
  ended_at: "Ended {0}",
  first_seen: "First seen {0}",

  upcoming: "Upcoming",
  ended: "Ended",

  input_number_format: "Please enter a numeric value.",
  input_array_format: "Please enter an array value.",
  input_string_format: "Please enter a string value.",

  field_type_not_match:
    'Imported value: "{value}" \nThis value couldn’t be matched to the {name} field.',
  already_exists: "This already exists. Please enter a different one.",

  invalid_url: "Invalid URL Format",
  select_date: "Pick a date",
  second_unit: "0 seconds | 1 second | {count} seconds",

  try_success: "Try successfully",
  try_failed: "Failed to try",

  // sort
  sort_popover_timestamp_ascending: "Oldest first",
  sort_popover_timestamp_descending: "Newest first",
  sort_popover_amount_ascending: "Lowest first",
  sort_popover_amount_descending: "Highest first",
  sort_popover_cost_duration_ascending: "Fastest first",
  sort_popover_cost_duration_descending: "Slowest first",
  sort_popover_alphabet_ascending: "A → Z",
  sort_popover_alphabet_descending: "Z → A",
  sort_popover_count_ascending: "Fewest first",
  sort_popover_count_descending: "Most first",

  last_modified: "Last modified",
  last_trigger_at: "Last trigger at",
  create_at: "Created at",
  total_credit: "Total credit",
  processing_time_ms: "Processing time (ms)",
  total_signals: "Total signals",
  retry_attempt: "Retry attempt",

  retry_success: "Retry successfully",
  retry_failed: "Failed to retry",
  no_logs_to_retry: "No logs available to retry",
  retry_partial_success:
    "{0}/{1} logs retried successfully. Please check the logs for details.",

  emailAlreadyExists: "The email address is already in use.",
  validateEmailFailed: "Failed to validate the email address.",

  array_input_placeholder: "Enter keywords and press the Enter key...",
  more_count: "+ {count} more",
  company_url_name: "Company",
  linkedin_url_name: "LinkedIn",
  facebook_url_name: "Facebook",
  instagram_url_name: "Instagram",
  twitter_url_name: "Twitter",
  youtube_url_name: "YouTube",
  github_url_name: "GitHub",
  tiktok_url_name: "TikTok",
  x_url_name: "X",
  crunchbase_url_name: "Crunchbase",
  wantedly_url_name: "Wantedly",
  rocketpunch_url_name: "Rocketpunch",
  angelist_url_name: "AngelList",
  pinterest_url_name: "Pinterest",
  remember_url_name: "Remember",
  tw104_url_name: "104.com.tw",
  vimeo_url_name: "Vimeo",
  vk_url_name: "VK",
  youtrust_url_name: "YouTrust",

  or: "or",
  and: "and",
  match_prefix: "Match:"
};

export default globalMessageEn;
